import script from "./Tabbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tabbar.vue?vue&type=script&lang=ts&setup=true"

import "./Tabbar.vue?vue&type=style&index=0&id=69717b5b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69717b5b"]])

export default __exports__